import React from "react";
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { store } from "../../redux/store";
import { connect } from "react-redux";
import './claim.css';
import history from "../../auth/history";
import $, { timers } from "jquery";
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";
import FooterComponet from "../FooterComponent/FooterComponet";
import Select from 'react-select';
import moment from "moment";
import { setClaimResp } from "../../redux/misc-data/misc-data.action";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();

class ClaimUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            otpRef: '',
            message: '',
            amount: '',
            searchableBankList: [],
            txnId: '',
            enteredDate: '',
            txmModes: [
                { value: "Select", label: "Select" },
                { value: "Net Banking", label: "Net Banking" },
                { value: "UPI Transfer", label: "UPI Transfer" },
                { value: "Cheque", label: "Cheque" },

            ],
            txnMode: '',
            comment: '',
            selectedBankName: '',
            amountErrMsg: '',
            bankErrMsg: '',
            txnIdErrMsg: '',
            txnDateErrNsg: '',
            txnModeErrMsg: '',
            claimUploadErr: ''
        }
    }



    componentDidMount() {
        this.loadBankDetails();

    }
    componentWillUnmount() {
    }

    enterAmount = (event) => {
        event.preventDefault();
        this.setState({
            amount: event.target.value,
            amountErrMsg: '',
        })

    }
    enterTxnId = (event) => {
        event.preventDefault();
        this.setState({
            txnId: event.target.value,
            txnIdErrMsg: '',
        })

    }

    selectDate = (event) => {
        event.preventDefault();
        this.setState({
            enteredDate: event.target.value,
            txnDateErrNsg: '',
        })

    }
    txnModeSelect = (event) => {
        if (event.target.value == 'Select') {
            alert('Please select a Transaction Mode');
            this.setState({
                txnModeErrMsg: 'Please select valid Id'
            })
        } else {
            this.setState({
                txnMode: event.target.value,
                txnModeErrMsg: ''
            })
        }
    }

    enterComment = (event) => {
        event.preventDefault();
        this.setState({
            comment: event.target.value
        })
    }

    loadBankDetails() {
        var searchableBankList = [];
        var bankDetailsUrl = '/api/v1/catalog/bank/all/summary';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        httpClient.get(bankDetailsUrl, { headers }
        ).then((response) => {
            console.log('all bank details' + JSON.stringify(response.data));
            if (response.data.length > 0) {
                if (response.data != null && response.data != undefined && response.data != '') {
                    this.setState({
                        bankDetails: response.data
                    })
                    if (response.data.length > 0) {
                        response.data.map(bank => {
                            var stateVal = {
                                value: '',
                                label: ''
                            }
                            stateVal.value = bank.name;
                            stateVal.label = bank.name;
                            searchableBankList.push(stateVal);
                        })
                    }
                }
                this.setState({
                    searchableBankList: searchableBankList
                })
            }
        }
        ).catch(error => {
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }
        
        });
    }
    bankChange = (selected) => {
        this.setState({
            selectedBankName: selected.label,
            bankErrMsg: '',
        })
    }

    submitClaimValidation() {

        this.setState({
            amountErrMsg: '',
            bankErrMsg: '',
            txnIdErrMsg: '',
            txnDateErrNsg: '',
            txnModeErrMsg: ''
        })

        var amountValidation = false;
        var bankValidation = false;
        var txnIdValidation = false;
        var txnDateValidation = false;
        var txnModeValidation = false;

        if (this.state.amount != '') {
            amountValidation = true;
        } else {
            this.setState({
                amountErrMsg: 'Please enter valid amount'
            })
        }
        if (this.state.selectedBankName != '' && this.state.selectedBankName != 'Select') {
            bankValidation = true;
        } else {
            this.setState({
                bankErrMsg: 'Please select bank'
            })
        }
        if (this.state.txnId != '') {
            txnIdValidation = true;
        } else {
            this.setState({
                txnIdErrMsg: 'Please enter transaction-id'
            })
        }
        if (this.state.enteredDate != '') {
            txnDateValidation = true;
        } else {
            this.setState({
                txnDateErrNsg: 'Please select a date'
            })
        }
        if (this.state.txnMode != '' && this.state.txnMode != 'Select') {
            txnModeValidation = true;
        } else {
            this.setState({
                txnModeErrMsg: 'Please select a Transaction Mode'
            })
        }


        if (amountValidation == true &&
            bankValidation == true &&
            txnIdValidation == true &&
            txnModeValidation == true &&
            txnDateValidation == true
        ) {
            return true;
        } else {
            return false;
        }

    }

    submitClaim = (event) => {

        event.preventDefault();

        this.setState({
            claimUploadErr: ''
        })
        var validation = this.submitClaimValidation();
        if (validation == true) {

            var submitClaimUrl = '/api/v1/virtual-balance/claim/create';
            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }

            var request = {
                entityId: this.props.agentInfo.id,
                amount: this.state.amount,
                utr: this.state.txnId,
                refId: uuidv4(),
                bank: this.state.selectedBankName,
                txnDate: moment(this.state.enteredDate).format('YYYY-MM-DD'),
                txnMode: this.state.txnMode,
                Comment: this.state.comment
            }


            httpClient.post(submitClaimUrl, request, { headers }
            ).then((response) => {
                console.log('claim response' + JSON.stringify(response.data));
                if (response.data != null &&
                    response.data != undefined &&
                    response.data != '') {
                    store.dispatch(setClaimResp(response.data));

                    var gotoClaimDetails = document.getElementById('gotoClaimDetails');
                    gotoClaimDetails.click();


                }
            }
            ).catch(error => {
                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                }
                this.setState({
                    claimUploadErr: 'Something went wrong'
                })
       
            });
        }
    }
    render() {

        return (
            <div>
                <HeadeCommon />
                <Menu />

                <div class="mid">
                    <div class="container-fluid">

                        <div class="head">
                            <br />
                            <h3>Claim TA Load</h3>
                            <Link to='/taload'>
                            <button class="btn" type="button" >TALoad</button>
                            </Link>
                        
                            <Link to='/claim-details'>
                                <button id='gotoClaimDetails' hidden={true}></button>
                            </Link>
                        </div>
                        <form onSubmit={this.submitClaim}>
                            <div class="addform">
                                <div class="row">
                                    <div class="col-12 col-lg-8">
                                        <div class="row">
                                            <div class="col-12 col-md-6">
                                                <div class="formrow">
                                                    <div class="form-floating">
                                                        <input type="number" class="form-control" id="amnt" placeholder="Amount"
                                                        onInput={(e) => e.target.value = e.target.value.slice(0, 11)}
                                                            onChange={this.enterAmount}
                                                            required />
                                                        <label for="amnt">Enter Amount</label>
                                                    </div>
                                                </div>
                                                {this.state.amountErrMsg != '' &&
                                                    <div class='valid-error'>
                                                        {this.state.amountErrMsg}
                                                    </div>
                                                }
                                            </div>

                                            <div class="col-12 col-md-6">
                                                <div class="formrow">
                                                    <div class="form-floating">
                                                        <Select class="mdb-select" options={this.state.searchableBankList}
                                                            SelectContainer={true}
                                                            defaultValue={{ label: 'Select Bank', value: 'Select Bank' }}
                                                            onChange={this.bankChange}
                                                            placeholder='Select Bank'
                                                        />
                                                    </div>
                                                </div>
                                                {this.state.bankErrMsg != '' &&
                                                    <div class='valid-error'>
                                                        {this.state.bankErrMsg}
                                                    </div>
                                                }
                                            </div>

                                            <div class="col-12 col-md-6">
                                                <div class="formrow">
                                                    <div class="form-floating">
                                                        <input type="text" class="form-control" id="txn" placeholder="Transaction ID"
                                                            onChange={this.enterTxnId}
                                                            required />
                                                        <label for="txn">Transaction ID</label>
                                                    </div>
                                                </div>
                                                {this.state.txnIdErrMsg != '' &&
                                                    <div class='valid-error'>
                                                        {this.state.txnIdErrMsg}
                                                    </div>
                                                }
                                            </div>

                                            <div class="col-12 col-md-6">
                                                <div class="formrow">
                                                    <div class="form-floating">
                                                        <input type="date" class="form-control" id="date" placeholder="Date"
                                                            onChange={this.selectDate}
                                                            required />
                                                        <label for="date">Transaction Date</label>
                                                    </div>
                                                </div>
                                                {this.state.txnDateErrNsg != '' &&
                                                    <div class='valid-error'>
                                                        {this.state.txnDateErrNsg}
                                                    </div>
                                                }
                                            </div>

                                            <div class="col-12 col-md-6">
                                                <div class="formrow">
                                                    <div class="form-floating">
                                                        <select class="form-select" id="txnMode" aria-label=""
                                                            onChange={this.txnModeSelect} required>
                                                            {this.state.txmModes.map(txnMode => (
                                                                <option value={txnMode.value}
                                                                >{txnMode.label}</option>
                                                            ))}
                                                        </select>
                                                        <label for="txnMode">Transaction Mode</label>
                                                    </div>
                                                </div>
                                                {this.state.txnModeErrMsg != '' &&
                                                    <div class='valid-error'>
                                                        {this.state.txnModeErrMsg}
                                                    </div>
                                                }
                                            </div>

                                            <div class="col-12 col-md-6">
                                                <div class="formrow">
                                                    <div class="form-floating">
                                                        <input type="text" class="form-control" id="com" placeholder="Comment"
                                                            onChange={this.enterComment} />
                                                        <label for="com">Comment</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12">
                                                <button class="btn btn-primary" type="submit">Submit</button>
                                            </div>
                                            {this.state.claimUploadErr != '' &&
                                                <div class='valid-error'>
                                                    {this.state.claimUploadErr}
                                                </div>
                                            }

                                            <div class="col-12">
                                                <div class="notxt">
                                                    <p>If the transaction was a success, your Corporate account would be credited instantly once (Only during Banking hours).</p>
                                                    <p class="text-danger">Note - This won’t be applicable if your official bank account is Yes Bank.</p>
                                                </div>
                                            </div>


                                        </div>
                                    </div>

                                    <div class="col-12 col-lg-4">
                                        <div class="bankcard">
                                            <div class="btbtnsfr">
                                                <h4>Bank-to-Bank Transfer Details</h4>

                                                <p>Now you can load money in your corporate virtual account through NEFT/RTGS as per process shown below.</p>

                                                <p>Account Details for adding Payee as mentioned as below:</p>

                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-striped">
                                                        <tbody><tr>
                                                            <td>Payee Name:</td>
                                                            <td>Uvva Infotech Pvt. Ltd.</td>
                                                        </tr>
                                                            <tr>
                                                                <td>Account Number:</td>
                                                                <td>4248795778XXXX12</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Bank Name:</td>
                                                                <td>Yes Bank Ltd.</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Bank IFSC Code:</td>
                                                                <td>YESB0CMSNOC</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Account Type:</td>
                                                                <td>Current Account</td>
                                                            </tr>
                                                        </tbody></table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="bankcard">
                                            <div class="banksteps">
                                                <ul>
                                                    <li>
                                                        <i class="step1"></i>
                                                        <h6>Login to bank account and <br />go to "Fund Transfer"</h6>
                                                        <span class="steparrow"></span>
                                                    </li>
                                                    <li>
                                                        <i class="step2"></i>
                                                        <h6>Click on Add Beneficiary or <br />Register a new Payee</h6>
                                                        <span class="steparrow"></span>
                                                    </li>
                                                    <li>
                                                        <i class="step3"></i>
                                                        <h6>Select Other* Bank NEFT/RTGS <br />transfer and enter the amount</h6>
                                                        <span class="steparrow"></span>
                                                    </li>
                                                    <li>
                                                        <i class="step4"></i>
                                                        <h6>Click on "Confirm" button to <br />complete the transaction</h6>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <FooterComponet />
            </div>
        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token, loginTime, partner, logoName }
    , authReduce: { callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token, loginTime, partner, logoName, callBackUrl
});




export default connect(mapStateToProps, null)(ClaimUpload);
